//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios'

const VALIDITY_INTERVAL = 1000 * 60 * 5 // 5 minutes

export default {
  name: 'MessengerCodeDialog',
  data: function () {
    return {
      registerCode: null,
      registerCodeTime: null,
      remainingValidityTime: 0,
      timer: null,
      loading: false
    }
  },
  computed: {
    progress: function () {
      return this.remainingValidityTime / VALIDITY_INTERVAL
    }
  },
  created: function () {
    this.getCode()
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  methods: {
    getCode: function () {
      this.loading = true
      axiosGet({
        url: '/service/messenger/messengerStatus',
        onSuccess: response => {
          this.parseResponse(response.data.result)
        },
        onFailure: ''
      }).finally(() => {
        this.loading = false
      })
    },
    parseResponse: function (response) {
      const unregisteredCode = response && response.length && response.find(code => !code.isRegistered)
      if (unregisteredCode) {
        this.registerCode = unregisteredCode.registerCode
        this.registerCodeTime = unregisteredCode.registerCodeTime
        const remainingValidityTime = VALIDITY_INTERVAL - (Date.now() - unregisteredCode.registerCodeTime)
        if (remainingValidityTime > 0) {
          this.remainingValidityTime = remainingValidityTime
          this.startTimer()
        } else {
          this.remainingValidityTime = 0
        }
      }
    },
    startTimer: function () {
      this.timer = setInterval(() => {
        this.remainingValidityTime -= 1000
        if (this.remainingValidityTime <= 0) {
          this.remainingValidityTime = 0
          clearInterval(this.timer)
        }
      }, 1000)
    },
    onCopy: function (e) {
      e.stopPropagation()
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.registerCode], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    }
  }
}
